(function ($, njm) {
    'use strict';

    njm.views.tabQuote = Backbone.View.extend({


        events: {
        },

        initialize: function () {
            var $this = this;

            window.onProductBegin = function (data, event) {
                $this.processing($(event.target).closest('.item'), true);
            }
            $(".quotegriditem").on('click', function (event) {
                var $this = $(this);//cache the $(this) selector since it will be used more than once
                var hrefText = this.href;
                var productLabel = $this.children(".product-label").text();
                njmClientClickTracking.quoteLinkClicked("Quote Link Clicked", productLabel, hrefText);
            });
            $('.quotegriditem').filter(function () {
                var href = $(this).attr('href') + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
                return $(this).attr("href", href);
            });
            $('.quotegetStarted').filter(function () {
                var href = $(this).attr('href') + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
                return $(this).attr("href", href);
            });

            window.onProductComplete = function (data, event) {
                $this.processing($(event.target).closest('.item'), false);
                //To add Policy Message Screen               
                $('#policy-message-container').find('.nopolicyquote').filter(function () {
                    var href = $(this).attr('href') + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
                    $(this).attr("href", href);
                });
                var policymessageContainer = $('#policy-message-container').html();
                $('#policy-message-container').remove();
                if (!$('.screens-wrapper').find('.product-policy-message').length > 0) {
                    $('.screens-wrapper').append(policymessageContainer);
                    $('#policy-message-container').remove();
                }
                $this.initializeTabComponent();
            };

            window.onProductFailure = function (data, event) {
                var hrefText = this.url;
                var failureText = ""
                njmClientClickTracking.quoteLinkClicked("Quote Link Click Failed", failureText, hrefText);
            };
            window.onProductSuccess = function (data, event) {
                var hrefText = this.url;
                var productLabel = $(event.target).closest('.item').children(".product-label").text();
                njmClientClickTracking.quoteLinkClicked("Quote Link Click Success", productLabel, hrefText);
                var displayScreen = $('[data-screen="product-quote"]');
                var currentScreen = $('.comp-tab-quote').find('.screen.active');
                var hidQuoteStatus = $('#quote-product-status');
                if (typeof hidQuoteStatus.val() !== "undefined" && hidQuoteStatus.val() === "true") {
                    console.log("in maintenance mode");
                    var redirectUrl = $('#quote-product-redirectUrl').val()
                    window.open(redirectUrl, '_self');
                }
                else {
                    $this.slideLeft(currentScreen, displayScreen);
                    $this.initializeTabComponent();
                }

                if (typeof (CallTrk) !== null && typeof (CallTrk) !== 'undefined') {
                    CallTrk.swap();
                }
            };

            window.onConitnueQuoteSuccess = function (data, event) {
                njmClientClickTracking.quoteLinkClicked("Continue Saved Quote Link Click Success");
                var displayScreen = $('[data-screen="continue-quote"]');
                var currentScreen = $('.comp-tab-quote').find('.screen.active');

                $this.slideLeft(currentScreen, displayScreen);
                $this.initializeTabComponent();

                if (typeof (CallTrk) !== null && typeof (CallTrk) !== 'undefined') {
                    CallTrk.swap();
                }
            };
            window.onConitnueQuoteFailure = function (data, event) {
                var hrefText = this.url;
                var failureText = "Continue Saved Quote Link Click Failed"
                njmClientClickTracking.quoteLinkClicked("Continue Saved Quote Link Click Failed", failureText, hrefText);
            };
            window.onProductQuoteSubmit = function () {
                var displayScreen = $('[data-screen="product-pre-quote"]');
                var currentScreen = $('[data-screen="product-grid"]');
                var hidQuoteStatus = $('#quote-product-status');
                if (typeof hidQuoteStatus.val() !== "undefined" && hidQuoteStatus.val() === "true") {
                    console.log("in maintenance mode");
                    var redirectUrl = $('#quote-product-redirectUrl').val()
                    window.open(redirectUrl, '_self');
                }
                else {
                    $this.slideLeft(currentScreen, displayScreen);
                    $this.initializeTabComponent();
                    var currentHref = $('#btnProductPreQuote').attr('href');
                    if (typeof currentHref != "undefined") {
                        if (currentHref.indexOf("__RequestVerificationToken") < 1) {
                            var href = currentHref + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
                            $('#btnProductPreQuote').attr('href', href);
                        }
                    }
                }

                if (typeof (CallTrk) !== null && typeof (CallTrk) !== 'undefined') {
                    CallTrk.swap();
                }
            };

            window.onProductQuoteSuccess = function () {
                var hrefText = this.url;
                var zipcode = $('#zipcode').val();
                njmClientClickTracking.quoteLinkClicked("Zip Code Link Click Success", zipcode, hrefText);
                $('#zipSubmit').removeAttr('disabled');
                var currentHref = $('#btnProdMsgSubmit').attr('href');
                if (typeof currentHref != "undefined") {
                    if (currentHref.indexOf("__RequestVerificationToken") < 1) {
                        var href = currentHref + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
                        $('#btnProdMsgSubmit').attr('href', href);
                    }
                }
            };

            window.onProductQuoteComplete = function () {
                var displayScreen = $('[data-screen="product-qualification-merged"]');
                var qualificationScreen = $('[data-screen="product-qualification"]');
                var currentScreen = $('[data-screen="product-quote"]');
                var hidQuoteshortform = $('#quote-action-shortform');
                var hidQuoteAgent = $('#quote-action-agentsearch');
                var hidQuoteQBApp = $('#quote-action-qbapp');
                var hidQuoteZipBlock = $('#quote-action-zipBlock');
                var hidQuoteReferral = $('#quote-action-quoteReferral');
                var hidQuoteaction = $('#hidQuoteAction');
                var hidQuoteAppetiteAction = $('#quote-action-appetiteMsg');
                var hidQuoteInAppetiteAction = $('#quote-action-inappetiteMsg');
                var zipSubmitBtn = $('#zipSubmit');
                var hidProductCategory = $('#productCategory');
                var hidBusinessLob = $('#quote-lob-business');
                var zipCodeLabel = $('#zipCodeLabel');
                var appurl = $('#hidQuoteActionUrl').val();
                var hidQuoteStatus = $('#quote-product-status');
                if (typeof hidQuoteStatus.val() !== "undefined" && hidQuoteStatus.val() === "true") {
                    console.log("in maintenance mode");
                    var redirectUrl = $('#quote-product-redirectUrl').val()
                    window.open(redirectUrl, '_self');
                }
                else {
                    if (!(zipCodeLabel.hasClass('haserror'))) {

                        if (hidBusinessLob.val() === hidProductCategory.val()) {
                            $this.slideLeft(currentScreen, displayScreen);

                        } else {

                            if (typeof hidQuoteaction.val() !== "undefined" && typeof hidQuoteQBApp.val() !== "undefined" && hidQuoteaction.val() && hidQuoteQBApp.val()) {

                                if (hidQuoteaction.val() === hidQuoteQBApp.val()) {
                                    window.open(appurl, '_self');
                                }
                                else if (hidQuoteaction.val() === hidQuoteshortform.val()) {
                                    var formUrl = $('#hidFormActionUrl').val();
                                    window.open(formUrl, '_self');
                                }
                                else if (hidQuoteaction.val() === hidQuoteAgent.val()) {
                                    var agentSearchUrl = $('#hidAgentActionUrl').val();
                                    window.open(agentSearchUrl, '_self');
                                }
                                else if (hidQuoteaction.val() === hidQuoteZipBlock.val()) {
                                    var zipBlockUrl = $('#hidzipBlockActionUrl').val();
                                    window.open(zipBlockUrl, '_self');
                                }
                                else if (hidQuoteaction.val() === hidQuoteReferral.val()) {
                                    var quoteReferralUrl = $('#hidquoteReferralActionUrl').val();
                                    window.open(quoteReferralUrl, '_self');
                                }
                                else if (hidQuoteaction.val() === hidQuoteAppetiteAction.val() || hidQuoteaction.val() === hidQuoteInAppetiteAction.val()) {
                                    $this.slideLeft(currentScreen, displayScreen);
                                }
                            }
                            else {
                                $this.slideLeft(currentScreen, displayScreen);
                            }
                        }
                    }
                }
                $this.processing(zipSubmitBtn, false);
                $this.initializeTabComponent();
            };
            window.onPreProductQuoteSuccess = function () {
                var displayScreen = $('[data-screen="product-quote"]');
                var currentScreen = $('[data-screen="product-pre-quote"]');
                $('#zipCodeLabel').removeClass('haserror');
                $this.slideLeft(currentScreen, displayScreen);
                $this.initializeProductQuoteComponent();

                if (typeof (CallTrk) !== null && typeof (CallTrk) !== 'undefined') {
                    CallTrk.swap();
                }
            };
            window.onProductQuoteQualificationSuccess = function () {
                var displayScreen = $('[data-screen="product-qualification-merged"]');
                var currentScreen = $('[data-screen="product-qualification"]');
                $this.slideLeft(currentScreen, displayScreen);
                $this.initializeTabComponent();
            };
            window.onProductQuoteError = function (data) {
                var hrefText = this.url;
                var zipcode = $('#zipcode').val();
                njmClientClickTracking.quoteLinkClicked("Zip Code Link Click Failed", zipcode, hrefText);
                //var hidErrorMsg = $('#hidErrorMessage');
                var hidZipErrorMsg = $('#hidGenericErrorMessage');
                var hidZipInvalidMsg = $('#hidZipCodeErrorMessage');
                var zipSubmitBtn = $('#zipSubmit'),
                    zipLabel = $('#zipCodeLabel').addClass('haserror');
                $('#zipErrorMsg').text(hidZipErrorMsg.val());
                if (data && data.status === 400) {
                    $('#zipErrorMsg').text(hidZipInvalidMsg.val());
                }
                else {
                    $('#zipErrorMsg').text(hidZipErrorMsg.val());
                    //  $('#zipErrorMsg').text(data.statusText);
                }
                $this.processing(zipSubmitBtn, false);
            };
            window.onValidateZipCode = function (data, event) {
                var hrefText = this.url;
                var zipcode = $('#zipcode'),
                    errorMsg = $('#zipcode').attr('data-val-required'),
                    zipSubmitBtn = $('#zipSubmit'),
                    zipRegEx = /\d{5}/,
                    error = zipcode.siblings('label').find('.tooltip'),
                    valid = zipRegEx.test(zipcode.val());
                njmClientClickTracking.quoteLinkClicked("Zip Code Link Clicked", zipcode.val(), hrefText);
                if (valid) {
                    error.parent().addClass('validated').removeClass('haserror');
                    if (zipSubmitBtn.hasClass('button')) {
                        zipSubmitBtn.attr('disabled', 'disabled');
                    }
                    $this.processing(zipSubmitBtn, true);
                } else {
                    error.parent().addClass('validated haserror');
                    $('#zipErrorMsg').text(errorMsg);
                    $this.processing(zipSubmitBtn, false);
                }
                return valid;
            }
            window.onGetStartedSuccess = function (response) {
                var hidQuoteStatus = $('#quote-product-status');
                if (typeof hidQuoteStatus.val() !== "undefined" && hidQuoteStatus.val() === "true") {
                    console.log("In maintenance mode");
                    var redirectUrl = $('#quote-product-redirectUrl').val()
                    window.open(redirectUrl, '_self');
                }
                if (response.getStartedUrl) {
                    window.location.href = response.getStartedUrl;
                }
            };
            window.onGetStartedFailure = function (xhr, status, error) {
                var hrefText = this.url;
                var failureText = "Get Started Link Click Failed"
                njmClientClickTracking.quoteLinkClicked("Get Started Link Click Failed", failureText, hrefText);
            };
            $this.initializeTabComponent();
        },
        initializeProductQuoteComponent: function () {
            var $this = this;
            var component = $('.comp-tab-quote');
            var quoteScreen = $('.comp-tab-quote [data-screen="product-quote"]');
            component.find('[data-screen="product-quote"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });
            quoteScreen.find('#zipcode').on({
                blur: function () {
                    $this.hideErrors();
                }
            });
        },
        initializeTabComponent: function () {
            var $this = this,
                component = $('.comp-tab-quote'),
                gridScreen = $('.comp-tab-quote [data-screen="product-grid"]'),
                quoteScreen = $('.comp-tab-quote [data-screen="product-quote"]'),
                msgScreen = $('.comp-tab-quote [data-screen="product-message"]'),
                preQualScreen = $('.comp-tab-quote [data-screen="product-qualification"]');

            component.find('#zipSubmit-Container').on({
                keydown: function () {
                    var key = event.which;

                    if (key === 13) {
                        component.find('#zipSubmit').trigger('click');
                    }
                }
            });
            component.find('.tab').on({
                click: function (event) {
                    $this.tabClick(event);
                }
            });

            msgScreen.find('.back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });

            component.find('[data-screen="product-quote"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });
            component.find('[data-screen="continue-quote"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });
            component.find('[data-screen="product-qualification"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });

            component.find('[data-screen="product-pre-quote"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });

            quoteScreen.find('#zipcode').on({
                blur: function () {
                    $this.hideErrors();
                }
            });

            component.find('[data-screen="product-message"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });

            component.find('[data-screen="product-qualification"] input[type="radio"]').on({
                change: function () {
                    $this.preQualRadioChecked(event);
                    if ($(this).parents('.validated').length > 0) {
                        $this.validatePreQual(event);
                    }
                }
            });
            component.find('[data-screen="product-qualification"] .prequal-button').on({
                click: function (event) {
                    var $thisObject = $(this);//cache the $(this) selector since it will be used more than once
                    var hrefText = this.href;
                    var productLabel = $thisObject.text();
                    njmClientClickTracking.quoteLinkClicked("Quote Link Clicked", productLabel, hrefText);
                    $this.validatePreQual(event);
                }
            });
            //Policy Option Selection Validation
            component.find('[data-screen="product-pre-quote"] #policy-options-button').on({
                click: function (event) {
                    var valid = $this.validatePolicyOption(event);

                    if (valid) {
                        $this.policyOptionSubmit(event);
                    }

                    event.preventDefault();
                }
            });

            component.find('[data-screen="product-pre-quote"] [name="productSelection"]').on({
                change: function (event) {
                    $this.validatePolicyOption(event);
                }
            });
            component.find('[data-screen="product-message-quote"] .back').on({
                click: function (event) {
                    $this.backClick(event);
                }
            });
        },
        AddAntiForgeryToken: function (event) {
            event.target.href = event.target.href + "&__RequestVerificationToken=" + $('input[name="__RequestVerificationToken"]')[0].value;
        },
        slideLeft: function (hideScreen, displayScreen) {

            if (!$('.comp-tab-quote').hasClass('sliding')) {

                $('.comp-tab-quote').addClass('sliding');

                displayScreen.addClass('right').removeClass('slide hidden active');

                window.setTimeout(function () {
                    hideScreen
                        .addClass('slide left');

                    displayScreen
                        .removeClass('right left hidden')
                        .addClass('slide active');
                }, 50);

                window.setTimeout(function () {
                    hideScreen.addClass('hidden').removeClass('slide left right active');
                    $('.comp-tab-quote').removeClass('sliding');
                }, 500);
            }
        },

        slideRight: function (hideScreen, displayScreen) {

            if (!$('.comp-tab-quote').hasClass('sliding')) {

                $('.comp-tab-quote').addClass('sliding');

                displayScreen.addClass('left').removeClass('slide hidden active');;

                window.setTimeout(function () {
                    hideScreen
                        .removeClass('active hidden')
                        .addClass('slide right');

                    displayScreen
                        .removeClass('right left hidden')
                        .addClass('slide active');
                }, 50);

                window.setTimeout(function () {
                    hideScreen.addClass('hidden').removeClass('slide left right active');
                    $('.comp-tab-quote').removeClass('sliding');
                }, 500);
            }
        },

        backClick: function (event) {
            event.preventDefault();
            var component = $('.comp-tab-quote');
            if (!component.hasClass('loading')) {
                var zipLabel = $('#zipCodeLabel').removeClass('haserror');
                var $this = this;
                var currentScreen = $(event.target).parents('.screen.active');
                var displayScreen;
                var href = component.find('.screen.active .back').attr('href');
                href = href.slice(1);
                displayScreen = component.find('[data-screen="' + href + '"]');
                $this.slideRight(currentScreen, displayScreen);
            }
        },

        tabClick: function (event) {
            event.preventDefault();
            var component = $('.comp-tab-quote');

            if (!component.hasClass('loading') && !component.hasClass('sliding')) {
                var $this = this;


                if (!$(event.target).hasClass('active')) {

                    if (!component.find('[data-screen="product-grid"]').hasClass('active')) {
                        component.find('.screen:not([data-screen="product-grid"])').removeClass('active left slide').addClass('right hidden');
                        component.find('[data-screen="product-grid"]').removeClass('left hidden right slide').addClass('active');
                    }

                    component.find('.tab.active').removeClass('active').attr('tabindex', '0');
                    $(event.target).addClass('active').removeClass('hidden').attr('tabindex', '-1');
                    var category = $(event.target).attr('data-category');

                    component.find('.screen[data-screen="product-grid"] .icon-grid.active').removeClass('active').addClass('hidden');
                    component.find('.screen[data-screen="product-grid"] .icon-grid[data-category="' + category + '"]').addClass('active').removeClass('hidden');
                }
            }
        },

        preQualRadioChecked: function (event) {
            var $this = this,
                numEmployees = $('[name="numEmployees"]'),
                numEmployeesChecked = numEmployees.closest(':checked'),
                numVehicles = $('[name="numVehicles"]'),
                numVehiclesChecked = numVehicles.closest(':checked'),
                submitBtn = $('#prequal-button'),
                ajaxBtn = $('#btnProdMsgSubmit'),
                arrow = '<i class="icon-arrow"></i>',
                businessRuleHidden = $('#quotebusinessrule').val(),
                quoteAppUrl = $('#quoteAppUrl').val(),
                formUrl = $('#quoteformUrl').val(),
                agentUrl = $('#quoteAgentUrl').val(),
                hidContinueText = $('#hidContinueBtnText').val(),
                hidOnlineQuoteText = $('#hidOnlineBtnText').val(),
                hidQuoteBtnText = $('#hidQuoteBtnText').val(),
                hidAgentBtnText = $('#hidAgentBtnText').val(),
                hidQuoteshortform = $('#quote-action-shortform').val(),
                hidQuoteAgentsearch = $('#quote-action-agentsearch').val(),
                hidQuoteAppetiteMsg = $('#quote-action-appetiteMsg').val(),
                displayEmpOptions = $('#product-qualification').attr('data-display-numEmployees'),
                displayVehicleOptions = $('#product-qualification').attr('data-display-numVehicles'),
                hidQuoteQbapp = $('#quote-action-qbapp').val();

            var result;
            var isProcessing = false;
            var businessRules = [];
            var businessRulesArr = JSON.parse(businessRuleHidden);

            if (displayEmpOptions === "True" && displayVehicleOptions === "True") {
                if (numEmployeesChecked.length + numVehiclesChecked.length === 2) {

                    result = businessRulesArr.find(function (x) {
                        return x.Employee === numEmployeesChecked.val() && x.Vehicle === numVehiclesChecked.val();
                    });
                    isProcessing = true;
                }
            }
            else if (displayEmpOptions === "True") {
                if (typeof numEmployeesChecked.val() !== "undefined" && numEmployeesChecked.val()) {
                    result = businessRulesArr.find(function (x) {
                        return x.Employee === numEmployeesChecked.val() && x.Vehicle === "";
                    });
                    isProcessing = true;
                }
            }
            else if (displayVehicleOptions === "True") {
                if (typeof numVehiclesChecked.val() !== "undefined" && numVehiclesChecked.val()) {
                    result = businessRulesArr.find(function (x) {
                        return x.Vehicle === numVehiclesChecked.val() && x.Employee === "";
                    });
                    isProcessing = true;
                }
            }
            submitBtn.show();
            ajaxBtn.hide();
            if (isProcessing) {
                if (typeof result !== "undefined" && typeof result.Action !== "undefined" && result.Action && result) {

                    if (result.Action === hidQuoteshortform) {
                        $this.processing(submitBtn, true);
                        window.setTimeout(function () {
                            $this.processing(submitBtn, false);
                            submitBtn.html(hidQuoteBtnText + arrow);
                            formUrl = formUrl + "&"
                            if (typeof $('[name="numEmployees"]').closest(':checked')[0] != "undefined" && typeof $('[name="numVehicles"]').closest(':checked')[0] != "undefined") {
                                formUrl = formUrl + encodeURIComponent("number of employees") + "=" + encodeURIComponent($('[name="numEmployees"]').closest(':checked')[0].value) + "&" + encodeURIComponent("number of vehicles") + "=" + encodeURIComponent($('[name="numVehicles"]').closest(':checked')[0].value);
                            }
                            else if (typeof $('[name="numVehicles"]').closest(':checked')[0] != "undefined") {
                                formUrl = formUrl + encodeURIComponent("number of vehicles") + "=" + encodeURIComponent($('[name="numVehicles"]').closest(':checked')[0].value);
                            }
                            else if (typeof $('[name="numEmployees"]').closest(':checked')[0] != "undefined") {
                                formUrl = formUrl + encodeURIComponent("number of employees") + "=" + encodeURIComponent($('[name="numEmployees"]').closest(':checked')[0].value);
                            }
                            submitBtn.attr('href', formUrl).removeAttr('target');
                        }, 400);
                    }
                    else if (result.Action === hidQuoteAgentsearch) {
                        $this.processing(submitBtn, true);
                        window.setTimeout(function () {
                            $this.processing(submitBtn, false);
                            submitBtn.html(hidAgentBtnText + arrow);
                            submitBtn.attr('href', agentUrl).removeAttr('target');
                        }, 400);
                    }
                    else if (result.Action === hidQuoteQbapp) {
                        $this.processing(submitBtn, true);
                        window.setTimeout(function () {
                            $this.processing(submitBtn, false);
                            submitBtn.html(hidOnlineQuoteText + arrow);
                            submitBtn.attr('href', quoteAppUrl).attr('target', '_blank');
                        }, 400);
                    }
                    else {
                        $this.processing(submitBtn, true);
                        window.setTimeout(function () {
                            $this.processing(submitBtn, false);
                            submitBtn.text(hidContinueText);
                            submitBtn.attr('href', '#').removeAttr('target');
                            submitBtn.hide();
                            ajaxBtn.show();
                        }, 400);
                    }

                }
                else {
                    console.log("business rule result is null")
                    $this.processing(submitBtn, true);
                    window.setTimeout(function () {
                        $this.processing(submitBtn, false);
                        submitBtn.text(hidContinueText);
                        submitBtn.attr('href', '#').removeAttr('target');
                        submitBtn.hide();
                        ajaxBtn.show();
                    }, 400);
                }
            }
            else {
                console.log("valid options are not selected yet.");
            }
        },


        processing: function (element, boolean) {
            var loadingHtml = '<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><span class="spacer">&nbsp;</span>',
                component = element.parents('.comp-tab-quote'),
                itemOverlay = $('<div class="overlay"></div>').hide(),
                screenOverlay = $('<div class="overlay"></div>'),
                elementContents = element.contents(),
                formElements = element.parents('.screen').find('input, .button'),
                temp = $('<span class="processing" style="display:none"></span>'),
                movedContent;

            if (boolean) {
                component.addClass('loading');
                component.prepend(screenOverlay);
                formElements.each(function () {
                    $(this).attr('disabled', 'disabled');
                });

                if (element.hasClass('item')) {
                    element.addClass('loading').prepend(itemOverlay);
                    itemOverlay.html(loadingHtml);
                    itemOverlay.fadeIn();

                } else if (element.is('input')) {
                    this.processing(element.parents('.button'), true);

                } else if (element.hasClass('button')) {
                    element.append(temp);
                    temp.append(elementContents)
                    element.append(loadingHtml);
                    element.attr('disabled', 'disabled');

                }
            } else {
                if (element.is('input') || element.is('#zipSubmit-Container')) {
                    component.find('.overlay').fadeOut(500, function () {
                        this.remove();
                        component.removeClass('loading');
                        element.removeClass('loading');
                    });
                } else {
                    component.find('.overlay').remove();
                    component.removeClass('loading');
                    element.removeClass('loading');
                }

                if (element.is('input')) {
                    this.processing(element.parents('.button'), false);
                } else if (element.hasClass('button')) {
                    movedContent = element.find('span.processing').contents();
                    element.prepend(movedContent);
                    element.find('span.processing').remove();
                    element.find('.lds-spinner').fadeOut().remove();
                    element.find('.spacer').remove();
                }

                formElements.each(function () {
                    $(this).removeAttr('disabled');
                });
            }

        },

        validatePreQual: function (event) {
            var $thisComponent = $(event.target).parents('.comp-tab-quote'),
                numEmployees = $thisComponent.find('#numEmployees_radio'),
                numEmployeesOptions = $thisComponent.find('[name="numEmployees"]'),
                numEmployeesChecked = numEmployeesOptions.closest(':checked'),
                numVehicles = $thisComponent.find('#numVehicles_radio'),
                numVehiclesOptions = $thisComponent.find('[name="numVehicles"]'),
                numVehiclesChecked = numVehiclesOptions.closest(':checked'),
                prEqualButton = $thisComponent.find('#prequal-button'),
                displayEmpOptions = $thisComponent.find('[data-screen="product-qualification"]').attr('data-display-numEmployees'),
                displayVehicleOptions = $thisComponent.find('[data-screen="product-qualification"]').attr('data-display-numVehicles');

            if (displayEmpOptions === "True" && displayVehicleOptions === "True") {

                if (numEmployeesChecked.length != 1) {
                    numEmployees.addClass('haserror validated');
                } else {
                    numEmployees.removeClass('haserror');
                }

                if (numVehiclesChecked.length != 1) {
                    numVehicles.addClass('haserror validated');
                } else {
                    numVehicles.removeClass('haserror');
                }

            } else if (displayEmpOptions === "True") {
                if (numEmployeesChecked.length != 1) {
                    numEmployees.addClass('haserror validated');
                } else {
                    numEmployees.removeClass('haserror');
                }
            } else if (displayVehicleOptions === "True") {
                {
                    if (numEmployeesChecked.length != 1) {
                        numEmployees.addClass('haserror validated');
                    } else {
                        numEmployees.removeClass('haserror');
                    }
                }
            }
            if (numEmployees.hasClass('haserror') || numVehicles.hasClass('haserror')) {
                prEqualButton.attr('href', '#');
                event.preventDefault();
            }
        },

        validatePolicyOption: function (event) {
            var $thisComponent = $(event.target).parents('.comp-tab-quote'),
                productSelection = $thisComponent.find('#productSelection_radio'),
                productSelectionOptions = $thisComponent.find('[name="productSelection"]'),
                productSelectionChecked = productSelectionOptions.closest(':checked'),
                poButton = $thisComponent.find('#policy-options-button');

            if (productSelectionChecked.length != 1) {
                productSelection.addClass('haserror validated');
            } else {
                productSelection.removeClass('haserror');
                return true;
            }
            if (productSelection.hasClass('haserror')) {
                poButton.attr('href', '#');
                event.preventDefault();
                return false;
            }
        },

        policyOptionSubmit: function (event) {
            var $thisComponent = $(event.target).parents('.comp-tab-quote'),
                productSelectionOptions = $thisComponent.find('[name="productSelection"]'),
                productSelectionChecked = productSelectionOptions.closest(':checked'),
                productSelectionCheckedId = productSelectionChecked[0].id,
                currentScreen = $(event.target).parents('.screen.active'),
                displayScreen = $thisComponent.find('[data-screen-for="' + productSelectionCheckedId + '"]');

            if (productSelectionCheckedId) {
                console.log("productSelectionCheckedId- Slide screen to left");
                this.slideLeft(currentScreen, displayScreen);
            }

            event.preventDefault();
        },

        hideErrors: function () {
            var component = $('.comp-tab-quote');
            component.find('.haserror').removeClass('haserror');
        }
    });
})(jQuery, njm);
